import React from 'react';

export default function SVG(props: React.SVGAttributes<SVGElement>) {
    return (
        <svg
            className={props.className ? props.className : ''}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60 60"
        >
            <g stroke="none" strokeWidth="1" fillRule="evenodd">
                <path
                    d="M18,8 L21.96444,8 C23.06901,8 23.96444,8.89543 23.96444,10 L23.96444,14.4 C23.96444,15.50457 23.06901,16.4 21.96444,16.4 L18,16.4 C16.89543,16.4 16,15.50457 16,14.4 L16,10 C16,8.89543 16.89543,8 18,8 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M27.95556,8 L31.92,8 C33.02457,8 33.92,8.89543 33.92,10 L33.92,14.4 C33.92,15.50457 33.02457,16.4 31.92,16.4 L27.95556,16.4 C26.85099,16.4 25.95556,15.50457 25.95556,14.4 L25.95556,10 C25.95556,8.89543 26.85099,8 27.95556,8 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M37.91111,8 L41.87556,8 C42.98013,8 43.87556,8.89543 43.87556,10 L43.87556,14.4 C43.87556,15.50457 42.98013,16.4 41.87556,16.4 L37.91111,16.4 C36.80654,16.4 35.91111,15.50457 35.91111,14.4 L35.91111,10 C35.91111,8.89543 36.80654,8 37.91111,8 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M18,18.8 L21.96444,18.8 C23.06901,18.8 23.96444,19.69543 23.96444,20.8 L23.96444,25.2 C23.96444,26.30457 23.06901,27.2 21.96444,27.2 L18,27.2 C16.89543,27.2 16,26.30457 16,25.2 L16,20.8 C16,19.69543 16.89543,18.8 18,18.8 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M18,29.6 L21.96444,29.6 C23.06901,29.6 23.96444,30.49543 23.96444,31.6 L23.96444,36 C23.96444,37.10457 23.06901,38 21.96444,38 L18,38 C16.89543,38 16,37.10457 16,36 L16,31.6 C16,30.49543 16.89543,29.6 18,29.6 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M28.01778,18.8 L31.98222,18.8 C33.08679,18.8 33.98222,19.69543 33.98222,20.8 L33.98222,25.2 C33.98222,26.30457 33.08679,27.2 31.98222,27.2 L28.01778,27.2 C26.91321,27.2 26.01778,26.30457 26.01778,25.2 L26.01778,20.8 C26.01778,19.69543 26.91321,18.8 28.01778,18.8 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M28.01778,29.6 L31.98222,29.6 C33.08679,29.6 33.98222,30.49543 33.98222,31.6 L33.98222,36 C33.98222,37.10457 33.08679,38 31.98222,38 L28.01778,38 C26.91321,38 26.01778,37.10457 26.01778,36 L26.01778,31.6 C26.01778,30.49543 26.91321,29.6 28.01778,29.6 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M38.03556,18.8 L42,18.8 C43.10457,18.8 44,19.69543 44,20.8 L44,25.2 C44,26.30457 43.10457,27.2 42,27.2 L38.03556,27.2 C36.93099,27.2 36.03556,26.30457 36.03556,25.2 L36.03556,20.8 C36.03556,19.69543 36.93099,18.8 38.03556,18.8 Z"
                    fillOpacity="0.2"
                ></path>
                <path
                    d="M38.03556,29.6 L42,29.6 C43.10457,29.6 44,30.49543 44,31.6 L44,36 C44,37.10457 43.10457,38 42,38 L38.03556,38 C36.93099,38 36.03556,37.10457 36.03556,36 L36.03556,31.6 C36.03556,30.49543 36.93099,29.6 38.03556,29.6 Z"
                    fillOpacity="0.2"
                ></path>
                <g transform="translate(13.000000, 1.000000)">
                    <path d="M4,0 L30,0 C32.20914,0 34,1.79086 34,4 L34,54 C34,56.209139 32.20914,58 30,58 L4,58 C1.79086,58 0,56.209139 0,54 L0,4 C0,1.79086 1.79086,0 4,0 Z M32.5,46.25 L1.5,46.25 L1.5,5.75 L32.5,5.75 L32.5,46.25 Z M32.5,47.75 L32.5,54 C32.5,55.380712 31.38071,56.5 30,56.5 L4,56.5 C2.61929,56.5 1.5,55.380712 1.5,54 L1.5,47.75 L32.5,47.75 Z M32.5,4.25 L1.5,4.25 L1.5,4 C1.5,2.61929 2.61929,1.5 4,1.5 L30,1.5 C31.38071,1.5 32.5,2.61929 32.5,4 L32.5,4.25 Z M17,55.75 C19.07107,55.75 20.75,54.071068 20.75,52 C20.75,49.928932 19.07107,48.25 17,48.25 C14.92893,48.25 13.25,49.928932 13.25,52 C13.25,54.071068 14.92893,55.75 17,55.75 Z M17,54.25 C15.75736,54.25 14.75,53.242641 14.75,52 C14.75,50.757359 15.75736,49.75 17,49.75 C18.24264,49.75 19.25,50.757359 19.25,52 C19.25,53.242641 18.24264,54.25 17,54.25 Z"></path>
                </g>
            </g>
        </svg>
    );
}
